
import ArrowUp3 from "../../../assets/filled/ArrowUp3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowUp3Icon({ className, dataTestid = "ArrowUp3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowUp3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
